module.exports = __webpack_public_path__ + "img/app/extApp/img/icon-arrow-lf.58a0afcd9940db1d69df8723c56764b4.png";